/** Etiquetas de medios de pago para tickets y reportes. */
export const PAYMENT_METHOD_LABELS: Record<string, string> = {
  cash: "Efectivo",
  card_credit: "Tarjeta de crédito",
  card_debit: "Tarjeta de débito",
  yape: "Yape",
  plin: "Plin",
  transfer: "Transferencia",
  other: "Otro",
};

/** Nombre legible de cada rol de usuario. */
export const ROLE_LABELS: Record<string, string> = {
  tenant_owner: "Dueño",
  tenant_admin: "Admin",
  branch_admin: "Admin sucursal",
  cashier: "Cajero",
};
